import React, { createContext, useContext, useState } from 'react';

const QuizContext = createContext();

export const useQuiz = () => {
  const context = useContext(QuizContext);
  if (!context) {
    throw new Error('useQuiz must be used within QuizProvider');
  }
  return context;
};

export const QuizProvider = ({ children }) => {
  const [answers, setAnswers] = useState([]);
  const [leadData, setLeadData] = useState(null);
  const [resultId, setResultId] = useState(null);

  const addAnswer = (questionId, answer, points) => {
    setAnswers(prev => {
      const existing = prev.find(a => a.question_id === questionId);
      if (existing) {
        return prev.map(a => 
          a.question_id === questionId 
            ? { question_id: questionId, answer, points }
            : a
        );
      }
      return [...prev, { question_id: questionId, answer, points }];
    });
  };

  const calculateScores = () => {
    const total = answers.reduce((sum, ans) => sum + ans.points, 0);
    const block1 = answers.filter(a => a.question_id >= 1 && a.question_id <= 5).reduce((sum, ans) => sum + ans.points, 0);
    const block2 = answers.filter(a => a.question_id >= 6 && a.question_id <= 10).reduce((sum, ans) => sum + ans.points, 0);
    const block3 = answers.filter(a => a.question_id >= 11 && a.question_id <= 15).reduce((sum, ans) => sum + ans.points, 0);
    
    return {
      total,
      blocks: {
        oferta: block1,
        marketing: block2,
        ventas: block3
      }
    };
  };

  const resetQuiz = () => {
    setAnswers([]);
    setLeadData(null);
    setResultId(null);
  };

  return (
    <QuizContext.Provider value={{
      answers,
      addAnswer,
      leadData,
      setLeadData,
      resultId,
      setResultId,
      calculateScores,
      resetQuiz
    }}>
      {children}
    </QuizContext.Provider>
  );
};